import React, { useState, useRef } from 'react';

import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';

// Custom input for text (and drag-and-drop variables) without variable suggestions
export const CustomInputTexto = ({ value, onChange, placeholder }) => {
    const [dragOverType, setDragOverType] = useState(null); // null | 'variavel' | 'node'
    const inputRef = useRef(null);

    const handleDragOver = (e) => {
        e.preventDefault();
        const isVarType = !!e.dataTransfer.types.find(t => t === 'application/variavel');
        setDragOverType(isVarType ? 'variavel' : 'node');
    };
    const handleDragLeave = () => setDragOverType(null);
    const handleDrop = (e) => {
        e.preventDefault();
        const data = e.dataTransfer.getData('application/variavel');
        if (!data) return setDragOverType(null);
        const { nome } = JSON.parse(data);
        const placeholderText = `{{${nome}}}`;
        // insert at cursor position
        let newVal = value;
        if (inputRef.current) {
            const start = inputRef.current.selectionStart;
            const end = inputRef.current.selectionEnd;
            newVal = value.slice(0, start) + placeholderText + value.slice(end);
            // move caret after placeholder (optional)
        } else {
            newVal = value + placeholderText;
        }
        onChange(newVal);
        setDragOverType(null);
    };
    const handleChange = (e) => onChange(e.target.value);

    return (
        <div style={{ position: 'relative', width: '100%' }}>
            <input
                ref={inputRef}
                type="text"
                value={value}
                onChange={handleChange}
                placeholder={placeholder}
                onDragOver={handleDragOver}
                onDragLeave={handleDragLeave}
                onDrop={handleDrop}
                style={{ width: '100%', padding: '5px', marginTop: '4px' }}
            />
            {dragOverType === 'variavel' && (
                <CheckCircleIcon style={{ position: 'absolute', top: 7, right: 2, color: 'green', fontSize: 22, zIndex: 2 }} />
            )}
            {dragOverType === 'node' && (
                <CancelIcon style={{ position: 'absolute', top: 7, right: 2, color: 'red', fontSize: 22, zIndex: 2 }} />
            )}
        </div>
    );
};
